import {combineReducers} from "redux";
import {LoginReducers} from "./Account/Login.Reducer";
import {PermissionsReducer} from "./Permissions/Permissions.Reducer";
import {SelectedBranchReducer} from "./Branches/SelectedBranch.Reducer";
import {BranchesReducer} from "./Branches/Branches.Reducer";
import {EmailIntegrationReducer} from "./EmailIntegration/EmailIntegration.Reducer";
import {PortalReducer} from "./Portal/Portal.Reducer";

export const Reducers = combineReducers({
  LoginReducers,
  BranchesReducer,
  SelectedBranchReducer,
  EmailIntegrationReducer,
  PermissionsReducer,
  PortalReducer,
});
